/**
 * Lock focus to focusable elements within referred component, or the component itself (if there's no focusable elements)
 * {DOM Event} event that triggered focus treatment (usually Tab keydown)
 * {React Ref} reference to component which focus will be locked
 */
var trapFocus = function trapFocus(event, target) {
  if (!target) return event;
  var focusableElements = Array.from(target.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([disabled])')); // if no focusable children, set focus to itself

  if (!focusableElements.length) {
    target.focus();
    return event.preventDefault();
  }

  var firstElement = focusableElements[0];
  var lastElement = focusableElements[focusableElements.length - 1];

  if (focusableElements.length === 1 || !focusableElements.includes(document.activeElement) || document.activeElement === lastElement && !event.shiftKey) {
    firstElement.focus();
    return event.preventDefault();
  }

  if (document.activeElement === firstElement && event.shiftKey) {
    lastElement.focus();
    return event.preventDefault();
  }
};

export default trapFocus;